import { useAccessMeta } from "../hooks/useInstructions";

interface Props {
  allowedRoles: string[];
  allowedFlags: string[];
  onChange: (roles: string[], flags: string[]) => void;
}

export function AccessMatrixEditor({ allowedRoles, allowedFlags, onChange }: Props) {
  const { data: meta } = useAccessMeta();

  const toggleRole = (value: string) => {
    const next = allowedRoles.includes(value)
      ? allowedRoles.filter((r) => r !== value)
      : [...allowedRoles, value];
    onChange(next, allowedFlags);
  };

  const toggleFlag = (value: string) => {
    const next = allowedFlags.includes(value)
      ? allowedFlags.filter((f) => f !== value)
      : [...allowedFlags, value];
    onChange(allowedRoles, next);
  };

  if (!meta) return null;

  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
          Stanowisko
        </p>
        <div className="flex flex-wrap gap-2">
          {meta.roles.map((r) => (
            <button
              key={r.value}
              type="button"
              onClick={() => toggleRole(r.value)}
              className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
                allowedRoles.includes(r.value)
                  ? "bg-[var(--color-primary)] border-[var(--color-primary)] text-white"
                  : "border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-[var(--color-primary)]"
              }`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
          Uprawnienie (dowolne z wybranych)
        </p>
        <div className="flex flex-wrap gap-2">
          {meta.flags.map((f) => (
            <button
              key={f.value}
              type="button"
              onClick={() => toggleFlag(f.value)}
              className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
                allowedFlags.includes(f.value)
                  ? "bg-[var(--color-primary)] border-[var(--color-primary)] text-white"
                  : "border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-indigo-400"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {allowedRoles.length === 0 && allowedFlags.length === 0 && (
        <p className="text-xs text-amber-500">
          Brak wybranych uprawnień — instrukcja widoczna tylko dla dyrektora, prezesa i dewelopera.
        </p>
      )}
    </div>
  );
}
